import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import logo from '../assets/logo.webp';
import floatingElement from '../assets/floating-element.png'; // Cambia esto según el nombre de tu PNG

const Hero = styled.section`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #0077b6 0%, #0093e9 100%);
  color: #fff;
  padding: 2rem;
  position: relative;
  overflow: hidden;
`;

const TextContainer = styled.div`
  flex: 1;
  padding: 2rem;
  text-align: left;
  max-width: 1000px;
  z-index: 1; /* Ensure text is above animated elements */
`;

const LogoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  z-index: 1; /* Ensure logo is above animated elements */
`;

const Logo = styled.img`
  width: 80%;
  max-width: 500px;
  border-radius: 50%;
  box-shadow: 0 4px 20px rgba(135, 57,254, 0.9);
`;

const Title = styled.h1`
  font-size: 5rem;
  margin-bottom: 1rem;
  text-shadow: 0 0 10px rgba(255, 255, 255, 3);
`;

const Subtitle = styled.p`
  font-size: 2rem;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
`;

const FloatingElement = styled(motion.img)`
  position: absolute;
  width: 150px;
  height: 150px;
  z-index: 0; /* Ensure elements are below text and logo */
`;

const HeroSection = () => {
  const generateRandomSpeed = () => Math.random() * 5 + 5; // Velocidad aleatoria entre 5 y 10 segundos

  const floatingVariants = {
    animate: (custom) => ({
      x: [0, '100vw'],
      y: [custom, custom],
      transition: {
        x: {
          repeat: Infinity,
          repeatType: 'loop',
          duration: generateRandomSpeed(),
          ease: 'linear',
        },
      },
    }),
  };

  const renderFloatingElements = (count) => {
    const elementSpacing = 200 / count; // Espaciado uniforme entre elementos
    return Array.from({ length: count }).map((_, index) => (
      <FloatingElement
        key={index}
        src={floatingElement}
        custom={`${index * -elementSpacing + 50}vh`} // Altura uniforme
        variants={floatingVariants}
        animate="animate"
      />
    ));
  };

  return (
    <Hero>
      {renderFloatingElements(10)} {/* Genera 10 elementos flotantes */}
      <TextContainer>
        <Title>Welcome to AdChain</Title>
        <Subtitle>Revolutionizing Digital Advertising with Blockchain</Subtitle>
      </TextContainer>
      <LogoContainer>
        <Logo src={logo} alt="AdChain Logo" />
      </LogoContainer>
      {renderFloatingElements(20)} {/* Genera 10 elementos flotantes */}
    </Hero>
  );
};

export default HeroSection;
